import { List } from 'immutable';
import { IAction } from '@/types/redux';

import {
  SEARCH_THROUGH_DB,
  REGISTER_AUTOCOMPLETE,
  UNREGISTER_AUTOCOMPLETE,
  SET_DATA_SOURCE,
  CREATE_AUTOCOMPLETE,
  UNREGISTER_ALL_AUTOCOMPLETES,
  SET_CHOSEN_TEXT,
  SET_ORIGIN,
  SET_PRELOAD,
  OPTION_CHOSEN,
} from './constants';
import { IDBAutocompleteProps } from './index';

export interface ISearchThroughDatabaseAction extends IAction {
  searchText: string;
  searchField?: string;
  props: IDBAutocompleteProps;
}

export function searchThroughDB(searchField: string, searchText: string, props: Partial<IDBAutocompleteProps>) {
  return {
    type: SEARCH_THROUGH_DB,
    searchField,
    searchText,
    props,
  };
}

export function registerAutocomplete(name: string, textField: string, url: string) {
  return {
    type: REGISTER_AUTOCOMPLETE,
    name,
    textField,
    url,
  };
}

export function createAutocomplete(
  name: string,
  formName: string,
  textField: string,
  url: string,
  value: string,
  fetchedValues: any,
  preload?: any,
) {
  return {
    type: CREATE_AUTOCOMPLETE,
    name,
    formName,
    textField,
    url,
    value,
    fetchedValues,
    preload,
  };
}

export function unregisterAutocomplete(name: string) {
  return {
    type: UNREGISTER_AUTOCOMPLETE,
    name,
  };
}

export function setDataSource(name: string, textField: string, data: List<any>) {
  return {
    type: SET_DATA_SOURCE,
    name,
    textField,
    data,
  };
}

export function setOrigin(name: string, items: List<any>) {
  return {
    type: SET_ORIGIN,
    name,
    items,
  };
}
export function unregisterAllAutocompletes() {
  return {
    type: UNREGISTER_ALL_AUTOCOMPLETES,
  };
}

export function setChosenText(name: string, text: string) {
  return {
    type: SET_CHOSEN_TEXT,
    name,
    text,
  };
}

export function setPreload(name: string, preload: List<any>) {
  return {
    type: SET_PRELOAD,
    name,
    preload,
  };
}

export function optionChosen() {
  return {
    type: OPTION_CHOSEN,
  };
}
